




























































































import { Component, Prop, PropSync, Ref, Watch, Vue } from "vue-property-decorator";
import store from "@/store";
//  @utilities
import moment from "moment";
import numberHelper from "Utilities/number-helper";
import htmlEncoder from "Utilities/htmlencode-helper";
// @types
import { UserProfile } from "@/types/userProfile";
// @components
import ConfirmDialog from "@/components/ConfirmDialog.vue";
//  @clients
import UsersClient from "Clients/users-client";
//  @modules
import { getModule } from "vuex-module-decorators";
import UserModule from "@/store/clients/User.module";
import SnackbarModule from "@/store/clients/Snackbar.module";

const User = getModule(UserModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({
  components: {
    ConfirmDialog,
  },
})
export default class APIKeyModal extends Vue {
  @PropSync("value", { required: true, type: Boolean, default: false }) isModalActive!: boolean;
  @Prop({ type: String, default: "463px" }) width!: string;
  @Prop({ type: Object, default: null }) user!: UserProfile | null;
  @Ref("confirm") confirm!: any;

  // @Data
  APIKey: string = "";

  // @Watchers
  @Watch("user")
  onUserChange(newVal: UserProfile): void {
    if (newVal) this.APIKey = newVal.apiKey || "";
  }

  // @Methods
  close(): void {
    this.isModalActive = false;
  }

  async onGenerateApiKey() {
    try {
      if (!this.user) return;
      const confirmed = await this.confirm.open(
        "Generate API key",
        this.APIKey === "" ? "Are you sure you want to generate a API key?" : "If you generate a new API key the current one will be deleted. Are you sure you want to generate a new API key?"
      );
      if (!confirmed) return;
      this.APIKey = await UsersClient.generateApiKey(this.user.id);
      Snackbar.showSnackbar({ text: "API key generated successfully", color: "success" });
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to generate API key" });
    }
    this.$emit("onGenerate");
  }

  async onRemoveKey(): Promise<void> {
    try {
      if (!this.user) return;
      const confirmed = await this.confirm.open("Remove API key", "Are you sure you want to remove this API key?");
      if (!confirmed) return;

      await UsersClient.clearApiKey(this.user.id);
      this.APIKey = "";
      Snackbar.showSnackbar({ text: "API key removed successfully", color: "success" });
      this.$emit("onRemove");
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to remove API key", color: "error" });
    }
  }

  async copyToClipboard(): Promise<void> {
    try {
      if (!this.APIKey) {
        Snackbar.showSnackbar({ text: "No API key to copy", color: "ContentPrimary" });
        return;
      }

      // Try modern clipboard API first
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(this.APIKey);
        Snackbar.showSnackbar({ text: "API key copied to clipboard", color: "ContentPrimary" });
      } else {
        // Fallback for older browsers or non-secure contexts
        const textArea = document.createElement("textarea");
        textArea.value = this.APIKey;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        if (successful) {
          Snackbar.showSnackbar({ text: "API key copied to clipboard", color: "ContentPrimary" });
        } else {
          throw new Error("Copy command failed");
        }
      }
    } catch (error) {
      console.error("Failed to copy:", error);
      Snackbar.showSnackbar({ text: "Failed to copy API key", color: "ContentPrimary" });
    }
  }

  // @Hooks
}
